import { render } from "./DifficultySelector.vue?vue&type=template&id=1fdaec84&scoped=true"
import script from "./DifficultySelector.vue?vue&type=script&lang=js"
export * from "./DifficultySelector.vue?vue&type=script&lang=js"

import "./DifficultySelector.vue?vue&type=style&index=0&id=1fdaec84&scoped=true&lang=css"

import exportComponent from "/home/runner/work/marvel-lcg-randomizer/marvel-lcg-randomizer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdaec84"]])

export default __exports__